import { getRootVue } from '../../common/baseMain'
import { getRouter } from '../../common/baseRouter'

import Test from '../search/pages/Test.vue'
import DarkText from '../search/pages/DarkText.vue'
import Hot from '../search/pages/Hot.vue'
import Keywords from '../search/pages/Keywords.vue'
import BlackList from '../search/pages/BlackList.vue'
import ProperNoun from '../search/pages/ProperNoun.vue'
import PermissionManage from '../settings/pages/PermissionManage.vue'
import UserManage from '../settings/pages/UserManage.vue'
import RunSetting from '../search/pages/RunSetting.vue'
import Home from './Home.vue'

// get router config
const router = getRouter({
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/index',
      component: Test
    },
    {
      path: '/dark-text',
      component: DarkText
    },
    {
      path: '/hot',
      component: Hot
    },
    {
      path: '/keywords',
      component: Keywords
    },
    {
      path: '/black-list',
      component: BlackList
    },
    {
      path: '/proper-noun',
      component: ProperNoun
    },
    {
      path: '/settings/permission',
      component: PermissionManage
    },
    {
      path: '/settings/user',
      component: UserManage
    },
    {
      path: '/run-setting',
      component: RunSetting
    }
  ]
})

// 入口
getRootVue({
  router
})
